routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.orderDetail', {
      url: __env.routes.orderDetail,
      template: `<order-detail sh-ctrl="shCtrl"></order-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/order-detail/order-detail.config.js
 **/